<template>
  <section class="layout-pt-lg layout-pb-lg" :style="`background-color: var(--c-${vars.backgroundColor})`">
    <BlockSymbol :position-text="String(vars?.blockPositionText || '')" :block-color="String(vars?.blockColor || '')" :block-opacity="Number(vars?.blockOpacityNumber || 1)" />
    <div class="container tw-z-10">
      <div class="row justify-center">
        <div v-html="vars.titleHtml" class="text-center col-lg-10" />
      </div>

      <div class="row justify-center pt-60 md:pt-30">
        <div class="col-xl-6 col-lg-8 col-md-10">
          <div class="contactForm">
            <div class="contactForm__field">
              <div class="contactForm__caption tw-text-white">Name</div>
              <input type="text" />
            </div>

            <div class="contactForm__field mt-30">
              <div class="contactForm__caption tw-text-white">phone</div>
              <input type="text" />
            </div>

            <div class="contactForm__field mt-30">
              <div class="contactForm__caption tw-text-white">emaıl</div>
              <input type="text" />
            </div>

            <div class="mt-30" v-for="(card, index) in cards" :key="index">
              <nuxt-link
                :to="card.button_link"
                :external="true"
                :class="['tw-block', 'tw-w-full', `n-${card.button_type}`]"
              >
                {{ card.button_label }}
              </nuxt-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';
import BlockSymbol from '~/components/common/BlockSymbol.vue';

export default defineNuxtComponent({
  name: 'ContactForm',

  components: {
    BlockSymbol,
  },

  mixins: [ComponentMixin],

  computed: {
    cards() {
      return this.groupedVariables.cards;
    },
  },
});
</script>

<style scoped>
.block {
  font-size: 40em !important;
  font-weight: 900;
  color: var(--c-secondary);
  line-height: 0.8;
  z-index: -1;
  margin: 0;
  padding: 0;
  position: absolute;
  bottom: -80px !important;
  left: -90px !important;
}

.contactForm select,
.contactForm input:not([type='range']),
.contactForm textarea {
  font-size: 16px;
  line-height: 30px;
  border-bottom: 1px solid white;
  border-left: 1px solid white;
  border-right: 1px solid white;
  border-top: 1px solid white;
  padding-bottom: 10px;
  transition: all 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
  color: white;
  padding: 15px 10px;
}
</style>
